<template>
  <LayoutCard
    v-if="showCard"
    rounded
    data-cy="order-queue-position"
    :title="$t('screens.order.queuePositionTitle')"
    :subtitle="$t('screens.order.queuePositionSubtitle')"
  >
    <div class="order-queue-position">
      <div
        class="order-queue-position__number mt-4"
        data-cy="order-queue-position-number"
      >
        {{ queuePosition }}
      </div>
    </div>
  </LayoutCard>
</template>

<script>
import LayoutCard from '@/components/LayoutCard.vue';

export default {
  name: 'OrderQueuePosition',
  components: {
    LayoutCard,
  },
  props: {
    // null = not in the queue (not placed, finished, rejected) or the
    // display-orders-queue functionality is disabled.
    queuePosition: {
      type: Number,
      required: false,
      default: null,
    },
    status: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    showCard() {
      // Guards against a stale position on an order that already left the
      // queue (e.g. it was closed before the position update arrived).
      return this.queuePosition > 0 && !this.orderLeftQueue;
    },
    orderLeftQueue() {
      return ['closed', 'failed', 'rejected'].includes(this.status);
    },
  },
};
</script>

<style lang="scss" scoped>
.order-queue-position {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &__number {
    min-width: 80px;
    min-height: 80px;
    padding: 0 12px;
    border-radius: 8px;
    background-color: $color-background-gray;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    font-weight: 700;
  }
}
</style>
